var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 9.66732H10.833V4.66732C10.833 4.4463 10.7452 4.23434 10.5889 4.07806C10.4326 3.92178 10.2207 3.83398 9.99967 3.83398C9.77866 3.83398 9.5667 3.92178 9.41042 4.07806C9.25414 4.23434 9.16634 4.4463 9.16634 4.66732V9.66732H4.16634C3.94533 9.66732 3.73337 9.75512 3.57709 9.9114C3.42081 10.0677 3.33301 10.2796 3.33301 10.5007C3.33301 10.7217 3.42081 10.9336 3.57709 11.0899C3.73337 11.2462 3.94533 11.334 4.16634 11.334H9.16634V16.334C9.16634 16.555 9.25414 16.767 9.41042 16.9232C9.5667 17.0795 9.77866 17.1673 9.99967 17.1673C10.2207 17.1673 10.4326 17.0795 10.5889 16.9232C10.7452 16.767 10.833 16.555 10.833 16.334V11.334H15.833C16.054 11.334 16.266 11.2462 16.4223 11.0899C16.5785 10.9336 16.6663 10.7217 16.6663 10.5007C16.6663 10.2796 16.5785 10.0677 16.4223 9.9114C16.266 9.75512 16.054 9.66732 15.833 9.66732Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUPlus);
export default __webpack_public_path__ + "static/media/u_plus.05f792fb00e200913fe5d66d3e0693ed.svg";
export { ForwardRef as ReactComponent };